import { render, staticRenderFns } from "./ConsultationDetailPage.vue?vue&type=template&id=24379808&"
import script from "./ConsultationDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ConsultationDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports